import { Action, isAnyOf } from "@reduxjs/toolkit";
import { ListenerApi } from "core/src/store/store.types";
import { navigate } from "../useCases/navigate/navigate.use-case";
import { updateLocation } from "../useCases/update-location/updateLocation.use-case";

export const afterUpdateLocation = {
	matcher: isAnyOf(
		updateLocation.fulfilled,
	),
	effect: (action: Action, listenerApi: ListenerApi) => {
		listenerApi.dispatch(
			navigate({ pathname: listenerApi.getState().navigation.location.pathname })
		);
	}
};
